import React, { useContext } from "react";
import { Autocomplete, TextField } from "@mui/material";
import GroupBiorepositoryOps from "../FieldTags/GroupBiorepositoryOps";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const TrackingNumber = ({ trackingNumber, handleChange, pullLists, informedConsent, informedConsentApprover, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = informedConsent !== "No" && informedConsentApprover !== "No" && checkRole(user, [ROLES.BIOOPS, ROLES.APPROVER, ROLES.DCT]);

    return (
        <div className="planField">
            <GroupBiorepositoryOps />
            <Autocomplete
                name="trackingNumber"
                multiple
                freeSolo
                autoSelect
                options={[]}
                value={trackingNumber ? trackingNumber.split(",") : []}
                onChange={(_, newValue) => handleChange("trackingNumber", newValue)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={pullListLabels.trackingNumber}
                        InputLabelProps={{
                            shrink: true,
                            required: required,
                        }}
                        required={required}
                    />
                }
                disabled={!canEdit}
            />
            <HistoryLogElement pullLists={pullLists} label={"trackingNumber"} />
        </div>
    );
};

export default TrackingNumber;